import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import ui from "@alpinejs/ui";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";

export default function () {
    window.Alpine = Alpine;
    Alpine.plugin(ui);
    Alpine.plugin(intersect);
    Alpine.plugin(focus);
    Alpine.plugin(collapse);
    Alpine.start();
}